import { useCallback, useEffect, useState } from 'react';
import { useFeatureFlag } from '@moda/portal-stanchions';
import { useBreakpoint } from '@moda/om';

const RESET_DELAY_MS = 2000;

export const useNewShareIconFeatureFlag = () =>
  useFeatureFlag('new-share-icon', [{ default: false }, { if: true, then: true }]);

enum Mode {
  Resting,
  Copied
}

export const useProductShareV2 = () => {
  const [mode, setMode] = useState<Mode>(Mode.Resting);
  const [loading, setLoading] = useState(false);
  const { matches: isMobile } = useBreakpoint({ lt: 'sm' });

  useEffect(() => {
    if (mode !== Mode.Resting) {
      const timeoutId = setTimeout(() => {
        setMode(Mode.Resting);
      }, RESET_DELAY_MS);

      return () => clearTimeout(timeoutId);
    }
  }, [mode]);

  const handleCopy = useCallback(async () => {
    const shareableContent = {
      url: window.location.toString().replace(location.search, ''),
      title: window.document.title
    };

    try {
      if (isMobile && navigator.share && navigator.canShare?.(shareableContent)) {
        await navigator.share(shareableContent);

        setMode(Mode.Copied);

        return;
      }

      await navigator.clipboard.writeText(shareableContent.url);

      setMode(Mode.Copied);
    } catch {
      reportError(new Error(`Share V2 failed for: ${shareableContent.url}`));
    } finally {
      setLoading(false);
    }
  }, [isMobile]);

  return { mode, loading, handleCopy };
};
